import {createFileRoute} from '@tanstack/react-router';
import ResetPage from '@features/auth/reset/page';
import {z} from 'zod';

export const Route = createFileRoute('/auth/reset')({
  component: ResetPage,
  validateSearch(search: object) {
    return z
      .object({
        email: z.string().optional(),
      })
      .parse(search);
  },
});
